import React from "react";
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function Login() {
  const handleSignIn = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-atf-bg">
      {/* Left: editorial copy */}
      <div className="flex flex-col justify-between px-8 lg:px-16 py-10 paper-grain">
        <div>
          <div className="flex items-baseline gap-3">
            <span className="font-serif text-4xl tracking-tight text-atf-brand">AT&amp;F</span>
            <span className="eyebrow">International · Est. 2025</span>
          </div>
        </div>

        <div className="max-w-xl anim-fade-up">
          <div className="eyebrow mb-6">Partnership Distribution Ledger</div>
          <h1 className="display-serif text-5xl sm:text-6xl lg:text-7xl text-atf-brand mb-8">
            A transparent ledger for an
            <span className="italic text-atf-gold"> uncommon </span>
            partnership.
          </h1>
          <p className="text-atf-text2 leading-relaxed text-base max-w-md mb-10">
            Sign in to inspect your point allocation, your share of the distributable pool,
            and the firm-wide economics — calculated to the rupee, to the day, to the partner.
          </p>
          <button
            onClick={handleSignIn}
            data-testid="google-signin-button"
            className="group inline-flex items-center gap-3 bg-atf-brand text-white px-7 py-4 text-sm tracking-[0.18em] uppercase font-semibold hover:bg-atf-brand2 transition-colors"
          >
            <span>Continue with Google</span>
            <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </button>
          <p className="text-xs text-atf-text2 mt-6">
            Access is by allowlist. Speak to the firm administrator if you need credentials.
          </p>
        </div>

        <div className="flex items-center justify-between text-xs text-atf-text2 mt-10">
          <span>© AT&amp;F International, Inc.</span>
          <span className="font-mono">v 1.0 · prospectus-compliant</span>
        </div>
      </div>

      {/* Right: image panel */}
      <div className="relative hidden lg:block">
        <img
          src="https://images.pexels.com/photos/164370/pexels-photo-164370.jpeg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-atf-brand/40" />
        <div className="absolute inset-0 flex flex-col justify-end p-12 text-white">
          <div className="eyebrow !text-white/70 mb-4">Phase I · Allocation Model</div>
          <div className="font-serif text-3xl leading-tight max-w-md">
            “Profit, when distributed by formula rather than favour, becomes a record of
            <span className="italic"> who built the firm</span>.”
          </div>
          <div className="mt-8 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "50%", v: "Revenue" },
              { k: "15%", v: "Capital" },
              { k: "10%", v: "Tenure" },
            ].map((s) => (
              <div key={s.k}>
                <div className="font-serif text-3xl text-atf-gold">{s.k}</div>
                <div className="eyebrow !text-white/60 mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
